import { useState, useEffect, useCallback, Fragment, memo,Dispatch,SetStateAction } from "react";
import classNames from "classnames";
import styles from "./Navbar.module.scss";

// import { BurgerIcon } from "./components/icons";

import {
  AccountNav,
  ChatNav,
  CurrentPlanNav,
  TeamNav,
  MDNav,
  GPTModal,
} from "./components";

import { RoutePaths } from "pages/routePaths";

import useRouter from "hooks/useRouter";
import { useWindowSize } from "hooks/useWindowSize";
import { useAppNotification } from "hooks/services/AppNotification";
import { useToggleSidebar } from "hooks/services/ToggleSidebarProvider";

import { useSelector } from "redux/hooks";
import { IChat, getChatModels, setChatModel, ChatType } from "redux/actions";
import { IUploadFile } from "pages/ChatPage";
import { useSidebar } from "hooks/services/ReSizeSidebar/ReSizeSidebar";

interface IProps {
  onStartNewChat?: ({ toChat }: { toChat: boolean }) => void;
  isMainScreenOpen?: boolean;
  setChatSetting?: Dispatch<SetStateAction<boolean>>;
  chatItem?:IChat;
  isFileUploading?: boolean;
  uploadingFiles?: IUploadFile[];
  fileS3Link?: string[];
  isAnswerComplete?: boolean;
}

export const Navbar = memo(
  ({ onStartNewChat, isMainScreenOpen, setChatSetting, chatItem, isFileUploading,fileS3Link,
    uploadingFiles, isAnswerComplete
  }: IProps) => {
    
    const {
       theme,
       gptModel } = useSelector((state) => state.authReducer);
    const { isOpen, toggleSidebar } = useToggleSidebar();
    const { includeRoute, pathname } = useRouter();
    const { triggerNotification } = useAppNotification();
    const { width } = useWindowSize();
    const userDetail = useSelector((state) => state.authReducer.userDetail);
    const history = pathname.includes('/chat/history');
    const { showCreateWorkspace } = useSelector((state)=> state.workSpaceReducer);
    const isChat = includeRoute(RoutePaths.Chat);
    // Chat Models Model
    const [chatModelsModel, setChatModelsModel] = useState<boolean>(false);
    const toggleChatModelsModel = () => setChatModelsModel((prev) => !prev);
    const[loadModel,setLoadModel] = useState<boolean>(false);

    const onGetChatModels = useCallback(() => {
      if (userDetail?.token) {
        setLoadModel(true);
        const storedChatModel = localStorage.getItem("GptModel");
        getChatModels()
          .then((res: any) => {
            setLoadModel(false);
            if (isMainScreenOpen  && !history) {
              if (gptModel?.type?.includes(ChatType.image) && !gptModel?.type?.includes(ChatType.image_chat)){
              if (storedChatModel) {              
                setChatModel(JSON.parse(storedChatModel));
              } else {
                setChatModel(res[0]);
                localStorage.setItem('GptModel', JSON.stringify(res[0]));

              }
              }
            }
          })
          .catch((err: any) => {
            setLoadModel(false);
            triggerNotification({ message: err?.data?.message, type: "error" });
          });
      }
    }, [isMainScreenOpen]);

    useEffect(() => onGetChatModels(), []);
    const isShareChat = window.location.pathname.includes("share-chat")

    const {sidebarWidth} = useSidebar();
    return (
      <Fragment>
        <div
          className={classNames(styles.navbar, {
            [styles.light]: theme === "light" ,
            [styles.dark]: theme === "dark",
            [styles.light]: theme === "light" ,
            [styles.dark]: theme === "dark",
            [styles.isSidebarOpen]: isOpen && !isShareChat,
            [styles.reSizeNavBar]: width > 768 && isOpen && includeRoute(RoutePaths.Team),
            [styles.teamlight]: theme === "light" && (includeRoute(RoutePaths.Team) || includeRoute(RoutePaths.CurrentPlan)),
            [styles.shareChatLight]: theme === "light" && isShareChat,
            [styles.workSpacesBorder]: (includeRoute(RoutePaths.Workspaces) || includeRoute(RoutePaths.ThreadsHistory)),
            [styles.navBarDisable]: showCreateWorkspace,
            [styles.workSpacelight]: theme === "light" && (includeRoute(RoutePaths.Workspaces) || includeRoute(RoutePaths.ThreadsHistory) || isChat) ,
            [styles.workSpacedark]: theme === "dark" && (includeRoute(RoutePaths.Workspaces) || includeRoute(RoutePaths.ThreadsHistory)),
          })}
          style={{width: width > 768 && isOpen && !includeRoute(RoutePaths.Team) && !isShareChat? `calc(100% - ${sidebarWidth}px)`: '100%'}}
        >
          {(!isOpen && width <= 768) && (
            <div className={classNames(styles.buttonsContainer,{
              [styles.teamButtonContainer]: !includeRoute(RoutePaths.Chat),
              [styles.isbackdrop]: showCreateWorkspace,
            })}>
               <button
                className={classNames(styles.openSidebarBtn, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                  [styles.teamButtonContainer]: includeRoute(RoutePaths.Team) && theme === 'dark'
                })}
                onClick={toggleSidebar}
                data-testid='toggle-nav-bar-burger-icon'
              >
                {/* <BurgerIcon /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 11 13" fill="none">
                  <g clipPath="url(#clip0_4356_2449)">
                    <path d="M0.25 2.75C0.25 2.33516 0.585156 2 1 2H10C10.4148 2 10.75 2.33516 10.75 2.75C10.75 3.16484 10.4148 3.5 10 3.5H1C0.585156 3.5 0.25 3.16484 0.25 2.75ZM0.25 6.5C0.25 6.08516 0.585156 5.75 1 5.75H10C10.4148 5.75 10.75 6.08516 10.75 6.5C10.75 6.91484 10.4148 7.25 10 7.25H1C0.585156 7.25 0.25 6.91484 0.25 6.5ZM10.75 10.25C10.75 10.6648 10.4148 11 10 11H1C0.585156 11 0.25 10.6648 0.25 10.25C0.25 9.83516 0.585156 9.5 1 9.5H10C10.4148 9.5 10.75 9.83516 10.75 10.25Z" fill="#94A3B8"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_4356_2449">
                      <rect width="10.5" height="12" fill="white" transform="translate(0.25 0.5)"/>
                    </clipPath>
                  </defs>
                </svg>
              </button> 
            </div>
          )}

          {width > 768 && (
            <div className={styles.lgNav} 
            >
              {(includeRoute(RoutePaths.Chat) || includeRoute(RoutePaths.Workspaces) || includeRoute(RoutePaths.ThreadsHistory)) &&  (
                <ChatNav
                  isMainScreenOpen={isMainScreenOpen}
                  toggleChatModelsModel={toggleChatModelsModel}
                  setChatSetting={setChatSetting}
                  chatItem={chatItem}
                  fileS3Link={  fileS3Link}
                />
              )}
              {includeRoute(RoutePaths.Account) && <AccountNav />}
              {includeRoute(RoutePaths.Team) && <TeamNav />}
              {includeRoute(RoutePaths.CurrentPlan) && <CurrentPlanNav />}
            </div>
          )}

          {width <= 768 && (
            <div className={styles.mdNav}>
              <MDNav
                onStartNewChat={onStartNewChat}
                toggleChatModelsModel={toggleChatModelsModel}
                setChatSetting={setChatSetting}
                chatItem={chatItem}
                fileS3Link={ fileS3Link}
                isAnswerComplete={isAnswerComplete}
              />
            </div>
          )}
        </div>

        {chatModelsModel && (
          <GPTModal
          isMainScreenOpen={isMainScreenOpen}
            onClose={toggleChatModelsModel}
            onStartNewChat={onStartNewChat}
            isFileUploading={isFileUploading}
            loadModel={loadModel}
            uploadingFiles={uploadingFiles}
          />
        )}
      </Fragment>
    );
  }
);
